import { FileWithPath } from "react-dropzone";
import { ApiFile } from "../shared/interfaces";
import { FileUploadProps } from "../components/FileUpload";

export type UploadProgressCallback = (fileId: string, progress: number) => void;

export class FileUploader {
    /**
     * Upload a file with progress tracking
     * @param file The file to upload
     * @param onProgress Callback to track upload progress
     */
    public static async uploadFile(
        file: FileWithPath,
        onProgress?: UploadProgressCallback,
    ): Promise<ApiFile> {
        return new Promise((resolve, reject) => {
            const formData = new FormData();
            formData.append("file", file);
            formData.append("conversationId", "conversationId");

            const xhr = new XMLHttpRequest();

            if (onProgress) {
                xhr.upload.addEventListener("progress", (event) => {
                    if (event.lengthComputable) {
                        const progress = Math.round((event.loaded / event.total) * 100);
                        onProgress(file.name + Date.now(), progress);
                    }
                });
            }

            xhr.addEventListener("load", () => {
                if (xhr.status === 200) {
                    resolve(JSON.parse(xhr.responseText));
                } else {
                    reject(new Error(`Upload failed with status ${xhr.status}`));
                }
            });

            xhr.addEventListener("error", () => {
                reject(new Error("Upload failed"));
            });

            xhr.open("POST", "/api/file/upload");
            xhr.send(formData);
        });
    }

    /**
     * Create a FileUpload prop from a file
     * @param file The file to create props for
     * @param index The index of the file in the upload list
     */
    public static createFileUploadProps(file: File | FileWithPath, index: number): FileUploadProps {
        return {
            id: file.name + Date.now(),
            name: file.name,
            progress: 0,
            index: index,
            createdAt: new Date(),
            size: file.size,
        };
    }
}
